import React, { useState, useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import moment from 'moment'
import 'moment/min/locales'
import { isEmpty } from 'lodash'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import { Container } from 'reactstrap'
import { GeneralContext } from '../../../context/'
import ProductList from '../../../components/Common/ProductList/List'
import ApiService from '../../../data/services/ApiService'
import SupplierCard from '../../../components/Common/Cards/Supplier'
import SummaryCard from '../../../components/Common/Cards/Summary'
import PaymentMethodsCard from '../../../components/Common/Cards/PaymentMethods'
import UserDefaultAddressCard from '../../../components/Common/Cards/UserDefaultAddress'
import Sticky from '../../../components/Common/Sticky'

moment.locale('es')

const Datatable = (props) => {
  const generalContext = useContext(GeneralContext)
  const { setLoading, loading, setCartItemsCount, selectedPayType, setSelectedPayType } = generalContext

  const [cart, setCart] = useState({})
  const [list, setList] = useState([])
  const [userAddressId, setUserAddressId] = useState('')

  const [supplier, setSupplier] = useState('')

  const [couponCode, setCouponCode] = useState('')
  const [couponDetail, setCouponDetail] = useState({})
  const [couponReleased, setCouponReleased] = useState({})

  const [confirmOrderModal, setConfirmOrderModal] = useState(false)
  const toggleConfirmOrderModal = () => setConfirmOrderModal(!confirmOrderModal)

  const fetchData = async () => {
    try {
      setLoading(true)
      const response = await ApiService.getCart()

      if (!isEmpty(response.data.data)) {
        setCart(response.data.data)
        setList(response.data.data.lineItems)
        setSupplier(response.data.data.supplier)
        setCouponDetail(response.data.data.couponReleased ? response.data.data.couponReleased.coupon : {})
        setCouponReleased(response.data.data.couponReleased ? response.data.data.couponReleased : {})
        setCouponCode(response.data.data.couponReleased ? response.data.data.couponReleased.coupon.codeName : '')
      } else {
        setCart({})
        setList([])
        setSupplier('')
        setCouponDetail({})
        setCouponCode('')
      }
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    (async function fetch() {
      await fetchData()
    })()
    if (isEmpty(selectedPayType)) {
      setSelectedPayType('PAGO_EN_LINEA')
    }
  }, []) // eslint-disable-line

  useEffect(() => {
    setUserAddressId(props.userDefaultAddress && props.userDefaultAddress.id)
  }, [props.userDefaultAddress])

  const goToDetailOfProduct = (item) => {
    const { product } = item

    window.analytics.track("Go to product page", {
      product: {
        productId: product.id,
        productName: product.name,
        productCode: product.code,
        gender: product.gender,
        model: product.model,
        providerName: product.supplier.nombreComercial,
        brand: product.brand,
        family: product.family,
        category: product.category,
        subcategory: product.subcategory,
        buyPrice: product.buyPrice,
        wholeSalePrice: product.wholeSalePrice,
        retailPrice: product.retailPrice,
        description: product.description,
        variants: product.variants,
      },
    })

    props.history.push(`/producto/${product.slug}`)
  }

  const removeProduct = async (item) => {
    try {
      setLoading(true)
      const response = await ApiService.deleteCartItem(item.id)
      setCartItemsCount(response.data.itemsOnCart)
      toastr.success(`El producto fue eliminado del carrito.`, '¡Éxito!')
      await fetchData()
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  const onChangeProductQuantity = async (item, quantity) => {
    try {
      setLoading(true)
      const response = await ApiService.updateCartItemQuantity(item.id, { quantity })
      setCartItemsCount(response.data.itemsOnCart)
      toastr.success(`El producto fue actualizado.`, '¡Éxito!')
      await fetchData()
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    window.analytics.track(`Payment Initiated`)
    resumeOrderNextStep()
  }

  const resumeOrderNextStep = async () => {
    try {
      if (selectedPayType === 'PAGO_EN_LINEA') {
        setLoading(true)
        const orderCreatedId = await saveOrder('PENDIENTE_DE_PAGO')
        const paymentIntent =
          await ApiService.createIntentOfPayment({
            orderId: orderCreatedId,
          })
        props.history.push(`/carrito/${orderCreatedId}/pagar`, {
          clientSecret: paymentIntent.data.client_secret,
          paymentIntentId: paymentIntent.data.paymentIntentId,
          couponReleased,
        })
      } else {
        // Abrir modal de confirmar colocar pedido
        toggleConfirmOrderModal()
      }
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  const saveOrder = async (mode) => {
    const data = {
      userAddressId,
      mode,
      cartId: cart.id,
      payWithCard: selectedPayType === 'PAGO_EN_LINEA',
      paymentType: selectedPayType,
      couponReleasedId: couponReleased.id,
    }
    setLoading(true)
    try {
      const response = await ApiService.createOrder(data)
      if (!isEmpty(response.data)) {
        if (response.data.success) {
          if (isEmpty(mode)) {
            toastr.success(`El pedido fue guardado.`, '¡Éxito!')
            props.history.push(`/pedido-confirmado`, {
              cart: cart,
              orderConfirmed: response.data.order,
              settings: response.data.settings,
              paymentType: selectedPayType,
              paymentMethods: response.data.paymentMethods,
              oxxoResponse: response.data.oxxoResponse,
            })
          } else if (mode === 'PENDIENTE_DE_PAGO') {
            return response.data.orderIdCreated
          }
        }
      }
      setLoading(false)
    } catch (e) {
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      setLoading(false)
    }
  }

  const applyCoupon = async () => {
    try {
      setLoading(true)
      const result = await ApiService.checkCouponDiscount({
        couponCode,
        cartId: cart.id,
      })
      setCouponDetail(result.data.coupon)
      setCouponReleased(result.data)

      window.analytics.track("coupon used valid", {
        couponCode
      })
    } catch (e) {
      setCouponDetail({})
      if (e.response) {
        toastr.error(`${e.response.data.message}`, 'Error')
      } else {
        toastr.error(`${e}`, 'Error')
      }
    } finally {
      await fetchData()
      setLoading(false)
    }
  }

  const confirmOrder = () => {
    toggleConfirmOrderModal()
    saveOrder(null)
  }

  return (
    <React.Fragment>
      <Container fluid>
        {!isEmpty(cart) && (
          <PaymentMethodsCard
            setPaymentMethod={setSelectedPayType}
            paymentMethodSelected={selectedPayType}
          />
        )}
        {!isEmpty(cart) && !isEmpty(supplier) && (
          <SupplierCard
            logoUrl={supplier.logotipo}
          />
        )}
        {!isEmpty(cart) && (
          <React.Fragment>
            <SummaryCard
              cart={cart}
              loading={loading}
              couponCode={couponCode}
              setCouponCode={setCouponCode}
              applyCoupon={applyCoupon}
              couponDetail={couponDetail}
            />
            <UserDefaultAddressCard
              defaultAddress={props.userDefaultAddress}
              supplier={supplier}
            />
          </React.Fragment>
        )}
        <div style={{ marginBottom: '75px' }}>
          <ProductList
            list={list}
            viewProduct={goToDetailOfProduct}
            deleteProduct={removeProduct}
            showSetQuantity
            onChangeQuantity={onChangeProductQuantity}
            loading={loading}
          />
        </div>
      </Container>
      {!isEmpty(cart) && (
        <Sticky
          loading={loading}
          onlyMobile={false}
          showSecondButton
          secondButtonText={selectedPayType === 'PAGO_EN_LINEA' ? 'IR A PAGAR' : 'FINALIZAR PEDIDO'}
          secondButtonClass="btn-success"
          secondButtonValidation={isEmpty(userAddressId) || isEmpty(selectedPayType)}
          secondButtonAction={handleSubmit}
        />
      )}
      <div>
        <Modal isOpen={confirmOrderModal} toggle={toggleConfirmOrderModal}>
          <ModalHeader toggle={toggleConfirmOrderModal}>Finalizar pedido</ModalHeader>
          <ModalBody>
            ¿Estás segura que deseas finalizar tu pedido?
          </ModalBody>
          <ModalFooter>
            <Button className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2" onClick={toggleConfirmOrderModal}>No, aún no</Button>{' '}
            <Button color="primary" className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2" onClick={() => confirmOrder()}>Si, finalizar pedido</Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Datatable)
